import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'contractorfilter'
})
export class ContractorPipe implements PipeTransform {


  transform(value: any, args?: any): any {

    if (!value) { return []; }
    if (!args) { console.log(args); return []; }

    const d = value.filter(r => r.contractor_id === args);
    return d;

  }

}



// WEBPACK FOOTER //
// ./src/app/pipe/contractorfilter.pipe.ts